import React, { useState } from 'react'
import Next from "./FormSection/next";
import Submit from "./FormSection/submit";
import Thankyou from "./FormSection/thankyou";

function HeroSectionForm({ setIsModalOpen,pageName }) {
    const [state, setState] = useState(0);
    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        EmailAddress: '',
        Phone: '',
        educationalQualification: '',
        Country: '',
        testTaken: ''
    });

    const counter1 = () => {
        setState(state + 1)
    }
    const counter2 = () => {
        setState(state + 1)
    }
    const counter3 = () => {
        setIsModalOpen(false);
        setState(0)
    }

    return (
        <>
            {state == 0 && <Next counter1={counter1} formData={formData} setFormData={setFormData} pageName={pageName} />}
            {state == 1 && <Submit counter2={counter2} formData={formData} setFormData={setFormData}  />}
            {state == 2 && <Thankyou counter3={counter3} />}
        </>
    )
}

export default HeroSectionForm